<div class="product" [class.checked]="check==value && product.available">
    <div class="radio">
        <input type="radio" [id]="name" [attr.disabled]="!product.available ? '' : null" [(ngModel)]="check"
            [name]="name" [value]='value' (change)="change()">
        <label [for]="name" class="radio-label">

            <div easyzoom *ngIf="loadAvatar" class="main-img">
                <img [src]="product.avatar|absolutePath:'products'"
                    [attr.data-zoom-image]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="main-img" *ngIf="!loadAvatar">
                <div class="loading" *ngIf="loadAvatar"></div>
                <img appLazyLoad (lodedImage)="loadAvatar=true" [src]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>

            <div class="product-body">
                <h2>{{product.name}}</h2>
                <div class="menu-price" *ngIf="offer">
                    {{product.price}} €
                </div>
            </div>
            <div class="product-footer">
                <button *ngIf="product.available && (product.compositions.length>0 || product.maxNbrIngOptions>0 || product.hasSupp)"
                    (click)="personalize()" class="btn personalize" [disabled]="siteClose">
                    Personnaliser
                </button>
                <div class="indispo" *ngIf="!product.available">
                    <p>Indisponible</p>
                </div>
            </div>
        </label>
    </div>
</div>